"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = SearchInput;
var React = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _utils = require("@design/lib/utils");
var _inputGroup = require("@design/ui/input-group");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "onValueChange", "searchIcon", "resultsLabel", "disabled"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function focusSearchField(clearButton) {
  var _clearButton$closest;
  (_clearButton$closest = clearButton.closest("[data-slot=search-input]")) === null || _clearButton$closest === void 0 || (_clearButton$closest = _clearButton$closest.querySelector("input")) === null || _clearButton$closest === void 0 || _clearButton$closest.focus();
}
function SearchInput(_ref) {
  var className = _ref.className,
    value = _ref.value,
    onValueChange = _ref.onValueChange,
    _ref$searchIcon = _ref.searchIcon,
    searchIcon = _ref$searchIcon === void 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.SearchIcon, {}) : _ref$searchIcon,
    resultsLabel = _ref.resultsLabel,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var resultsAddon = resultsLabel == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, {
    align: "inline-end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupText, {
      "aria-live": "polite",
      className: "text-xs whitespace-nowrap tabular-nums",
      children: resultsLabel
    })
  });
  var clearButton = value ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, {
    align: "inline-end",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupButton, {
      size: "icon-xs",
      "aria-label": "Clear search",
      disabled: disabled,
      onMouseDown: function onMouseDown(event) {
        return event.preventDefault();
      },
      onClick: function onClick(event) {
        onValueChange("");
        focusSearchField(event.currentTarget);
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CloseIcon, {})
    })
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inputGroup.InputGroup, {
    "data-slot": "search-input",
    "data-disabled": disabled,
    className: (0, _utils.cn)("rounded-none border-0 border-b border-border-default bg-background-canvas dark:bg-background-canvas has-[[data-slot=input-group-control]:focus-visible]:border-border-focus has-[[data-slot=input-group-control]:focus-visible]:ring-0", className),
    "data-sentry-element": "InputGroup",
    "data-sentry-component": "SearchInput",
    "data-sentry-source-file": "search-input.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupAddon, {
      "data-sentry-element": "InputGroupAddon",
      "data-sentry-source-file": "search-input.tsx",
      children: searchIcon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_inputGroup.InputGroupInput, _objectSpread(_objectSpread({
      type: "search",
      value: value,
      onChange: function onChange(event) {
        return onValueChange(event.target.value);
      },
      disabled: disabled,
      className: "px-2! [&::-webkit-search-cancel-button]:appearance-none",
      "aria-label": props.placeholder
    }, props), {}, {
      "data-sentry-element": "InputGroupInput",
      "data-sentry-source-file": "search-input.tsx"
    })), resultsAddon, clearButton]
  });
}